import { FC, ReactNode, useEffect } from 'react';

import { useAppStore } from 'entities/user/model/store/useAppStore';
import { apiService } from 'shared/api/apiService';
import { EURO_SYMBOL_URI } from 'shared/lib/consts';
import { getCookie } from 'shared/lib/getCookie';
import { setCookie } from 'shared/lib/setCookie';

interface AuthProviderProps {
	children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
	const { setCurrency, setIsLoading } = useAppStore();

	useEffect(() => {
		setIsLoading(true);
		const currency = getCookie(`CP_SAS_CURRENCY`) ? getCookie(`CP_SAS_CURRENCY`) : EURO_SYMBOL_URI;

		setCurrency(decodeURIComponent(currency));

		(async () => {
			try {
				const response = await apiService.getToken({
					ClientApiId: `00000000-0000-0000-0000-000000000000`,
					SecretKey: null,
					ExpiryDate: `2036-03-31T11:42:12.858Z`,
				});
				setCookie(`CP_SAS_TOKEN`, response.Token, new Date(Date.now() + 1000 * 60 * 60 * 24 * 30));
			} catch (error) {
				console.error(error);
			} finally {
				setIsLoading(false);
			}
		})();
	}, [setCurrency, setIsLoading]);

	return children;
};
